export default {
  nameGroup: {
    value: '',
    maxlength: '55',
    required: true,
    state: null
  },
  inative: {
    value: null,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configurations/group/components/add/group-form.js